import 'jquery';
import { FTScroller } from 'ftscroller';
import './string.starts-with.js';

// menuItems should be in JSON in format [{ITEM1}, {ITEM2}, ..] 
// where ITEMX = { Name: NAME, Uri: URI, Id: ID, Items: [ITEMY, ITEMZ] }}
export class UnifyMenu {
    constructor(menuItems, domElement) {
        this.menuItems = menuItems;
        this._speedToShowHide = 0;
        this._scrollerOptions = {
            alwaysScroll: true,
            bouncing: false,
            scrollingY: false,
            scrollbars: false,
            updateOnWindowResize: true
        };
        this._sessionStorageKeyScrollPositions = 'UnifyMenuScrollPositions';
        this._menuRowScrollPositions = {};

        var menuRowScrollPositionsStr = window.sessionStorage[this._sessionStorageKeyScrollPositions];
        if (menuRowScrollPositionsStr) {
            this._menuRowScrollPositions = JSON.parse(menuRowScrollPositionsStr);
        } else {
            window.sessionStorage[this._sessionStorageKeyScrollPositions] = JSON.stringify({});
        }

        for (var i = 0; i < menuItems.length; i++) {
            var menuItem = menuItems[i];
            this._assignParents(menuItem);
        }

        this._rootRowElement = this._render(this.menuItems, domElement, '/');

        // set active from first 'IsActive'
        var activeMenuItem = this._getActiveElementFromMenuItems(this.menuItems);
        this._setActive(activeMenuItem, true, true);
    }

    _getActiveElementFromMenuItems(menuItems) {
        for (var i = 0; i < menuItems.length; i++) {
            var menuItem = menuItems[i];
            if (typeof menuItem.IsActive !== 'undefined' && !!menuItem.IsActive) {
                return menuItem;
            }
            if (menuItem.Items) {
                var found = this._getActiveElementFromMenuItems(menuItem.Items);
                if (found != null) {
                    return found;
                }
            }
        }

        return null;
    }

    _showBootstrapTab(menuItem, e) {
        var tab = menuItem.Uri;
        $('a[href="' + tab + '"]:visible').tab('show');
        // prevent href to be added to browser window
        if (typeof e !== "undefined" && e != null) {
            e.preventDefault();
        }
    }

    _getParents(menuItem) {
        var parents = [];
        var tmp = menuItem;
        while (this._hasParentMenu(menuItem)) {
            parents.push(menuItem.parent);
            menuItem = menuItem.parent;
        }
        return parents;
    }

    _hasParentMenu(menuItem) {
        return menuItem.parent != null && typeof menuItem.parent !== "undefined";
    }

    _hasSubmenu(menuItem) {
        return menuItem.Items != null && typeof menuItem.Items !== "undefined" && menuItem.Items.length > 0;
    }

    _getVisibleRowElements(menuItem) {
        var visibleRowElements = [];

        if (menuItem == null) {
            visibleRowElements.push(this._rootRowElement);
            return visibleRowElements;
        }

        if (this._hasSubmenu(menuItem)) {
            visibleRowElements.push(menuItem.Items[0].rowElement);
        }

        while (menuItem) {
            visibleRowElements.push(menuItem.rowElement);
            menuItem = menuItem.parent;
        }

        return visibleRowElements;
    }

    _setActive(newActiveMenuItem, skipAnimation, firstCall) {
        var currentVisibleRowElements = (!!firstCall) ? [] : this._getVisibleRowElements(this.activeMenuItem);
        var newVisibileRowElements = this._getVisibleRowElements(newActiveMenuItem);

        for (var i = 0; i < currentVisibleRowElements.length; i++) {
            var row = currentVisibleRowElements[i];
            var index = $.inArray(row, newVisibileRowElements);
            if (index > -1) {
                newVisibileRowElements.splice(index, 1);
            } else {
                var speed = skipAnimation ? 0 : this._speedToShowHide;
                $(row).hide(speed);
            }
        }

        for (var i = 0; i < newVisibileRowElements.length; i++) {
            var row = newVisibileRowElements[i];

            var speed = skipAnimation ? 0 : this._speedToShowHide;
            $(row).show(speed, function () {
                this._scroller.updateDimensions();
            });
        }

        // remove active menuItem class (step over all to be sure to capture all items)
        this._removeActiveMenuItem(this.menuItems);

        // add active menuItem class
        this._addActiveMenuItem(newActiveMenuItem);

        // add row background-color class
        var newVisibleRowElements = this._getVisibleRowElements(newActiveMenuItem);
        var nrRows = newVisibleRowElements.length;
        for (var i = 0; i < nrRows; i++) {
            var row = newVisibleRowElements[i];

            if ((nrRows - i) % 2 === 0) {
                $(row).addClass('unify-visible-row-odd');
            }
            else {
                $(row).addClass('unify-visible-row-even');
            }
        }

        this.activeMenuItem = newActiveMenuItem;
    }

    _removeActiveMenuItem(menuItems) {
        for (var i = 0; i < menuItems.length; i++) {
            var menuItem = menuItems[i];
            $(menuItem.domElement).removeClass('unify-active');
            // think ftscroller adds active but do not remove it because of prevent default in our code (prevent #tag added to browser url)
            $(menuItem.domElement).removeClass('active');
            if (menuItem.Items) {
                this._removeActiveMenuItem(menuItem.Items);
            }
        }
    }

    _addActiveMenuItem(menuItem) {
        if (typeof menuItem === "undefined" || menuItem == null) {
            return;
        }

        $(menuItem.domElement).addClass('unify-active');
        if (typeof menuItem.parent !== 'undefined') {
            this._addActiveMenuItem(menuItem.parent);
        }
    }

    /**
     * Recursively populates the parent property of the child items of menuItem 
     * and all of its descendant menuItems.
     *
     * @param {Object} menuItem a menu item
     */
    _assignParents(menuItem) {
        if (!menuItem.Items) {
            return;
        }

        for (var j = 0; j < menuItem.Items.length; j++) {
            var child = menuItem.Items[j];
            child.parent = menuItem;
            this._assignParents(child);
        }
    }

    /** 
     * Recursively creates the menu rows, appends them to eachother, and then the supplied domElement.
     * @example
     *     <nav class="unify-menu unify-hidden">
     *         <div class="shadow-right">
     *         </div>
     *         <div class="row">
     *             <div class="col-xs-12">
     *                 <ul></ul>
     *             </div>
     *         </div>
     *     </nav>
     * @param {Object} menuItems the menu items
     * @param {HTMLElement} domElement the dom element
     * @param {string} menuUri the uri of the menu object
     * @returns {HTMLElement} the menu root element
     */
    _render(menuItems, domElement, menuUri) {
        if (menuItems == null || typeof menuItems === "undefined") {
            return null;
        }
        var activeMenuItemElement;
        var rowElement = document.createElement("nav");

        $(rowElement).addClass("unify-menu");
        $(rowElement).addClass("unify-hidden");
        var divRowElement = document.createElement("div");
        $(divRowElement).addClass('row');
        var divShadow = document.createElement('div');
        $(divShadow).addClass("shadow-right");

        var divColElement = document.createElement("div");
        $(divColElement).addClass('col-xs-12');
        var ulElement = document.createElement("ul");

        $(divColElement).append(ulElement);
        $(divRowElement).append(divColElement);
        $(rowElement).append(divShadow);
        $(rowElement).append(divRowElement);
        $(domElement).append(rowElement);

        $(domElement).append(rowElement);

        for (var i = 0; i < menuItems.length; i++) {
            var menuItem = menuItems[i];

            var menuItemElement = document.createElement("li");
            $(menuItemElement).addClass('unify-menu-item');
            ulElement.appendChild(menuItemElement);
            var href = typeof menuItem.Uri === 'undefined' || menuItem.Uri == null || menuItem.Uri == '' ? '' : ' href="' + menuItem.Uri + '"';
            var innerHtml = '<a' + href + '>' + menuItem.Name + '</a>';
            menuItemElement.innerHTML = innerHtml;

            this._render(menuItem.Items, domElement, menuItem.Uri);

            var that = this;
            //  do not set active if it will result in a post to server
            if (typeof menuItem.Uri === 'undefined' || menuItem.Uri == null || menuItem.Uri === '' || menuItem.Uri.indexOf('#') == 0) {
                $(menuItemElement).on('click', function (e) { that._setActiveFromElement(this, e); });
            }
            /* This will not always work if the menu is more than two levels deep. For example UIElements -> Highcharts would work, 
              but not UIElements -> Highcharts -> Line */
            if (window.location.pathname && menuItem.Uri && window.location.pathname.toLowerCase().startsWith(menuItem.Uri.toLowerCase())) {
                activeMenuItemElement = menuItemElement;
            }
            menuItem.domElement = menuItemElement;
            menuItem.rowElement = rowElement;
        }

        rowElement._scroller = new FTScroller(divRowElement, this._scrollerOptions);

        var menuHasActiveItem = !!activeMenuItemElement;
        var menuHasScrollPosition = !!this._getMenuScrollPosition(menuUri);

        if (menuHasActiveItem) {
            if (menuHasScrollPosition) {
                /* Ideally we would only execute this function if it would result in the item being fully visible.
                 However, making such a calculation would require the document to be ready, which is too late if we
                 are to prevent a jank. */
                this._applyMenuScrollPositionFromStorage(rowElement, menuUri);

                this._scrollActiveMenuItemIntoView(rowElement, activeMenuItemElement);
            } else {
                this._scrollActiveMenuItemIntoView(rowElement, activeMenuItemElement);
            }
        }

        rowElement._scroller.addEventListener('scrollend', (function (event) {

            this._storeMenuScrollPosition(event.scrollLeft, menuUri);
        }).bind(this));

        return rowElement;
    }

    _setActiveFromElement(itemElement, event) {
        var menuItem = this._findItemFromElement(this.menuItems, itemElement);
        this._setActive(menuItem);

        // show tab if bootstrap is used
        if (typeof menuItem.Uri === 'string' && menuItem.Uri.indexOf('#') == 0) {
            this._showBootstrapTab(menuItem, event);
        }
    }

    setActiveMenuObjectById(id) {
        var menuItemId = this._findItemFromId(this.menuItems, id);

        var menuItem = menuItemId;
        if (typeof menuItem === "undefined" || menuItem === null) {
            return;
        }

        this._setActive(menuItem);

        // show tab if bootstrap is used
        if (typeof menuItem.Uri === 'string' && menuItem.Uri.indexOf('#') == 0) {
            this._showBootstrapTab(menuItem, event);
        }
    }

    setActiveMenuObjectByUri(uri) {
        var menuItemUri = this._findItemFromUri(this.menuItems, uri);

        var menuItem = menuItemUri;
        if (typeof menuItem === "undefined" || menuItem === null) {
            return;
        }

        this._setActive(menuItem);

        // show tab if bootstrap is used
        if (typeof menuItem.Uri === 'string' && menuItem.Uri.indexOf('#') == 0) {
            this._showBootstrapTab(menuItem, event);
        }
    }

    setActiveMenuObject(uri) {
        this.setActiveMenuObjectByUri(uri);
    }

    _setActiveFromId(name) {
        var menuItem = this._findItemFromId(this.menuItems, name);
        if (typeof menuItem === "undefined" || menuItem === null) {
            return;
        }
        this._setActive(menuItem);

        // show tab if bootstrap is used
        if (typeof menuItem.Uri === 'string' && menuItem.Uri.indexOf('#') == 0) {
            this._showBootstrapTab(menuItem, event);
        }
    }

    _findItemFromUri(items, uri) {
        if (items == null || typeof items === "undefined") {
            return null;
        }

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item == null || typeof item === "undefined") {
                continue;
            }

            if (item.Uri != null) {
                // Trim last '/' character if it exists and it is not the initial '/'.
                var itemUri = item.Uri;
                if (itemUri !== '/' && itemUri.charAt(itemUri.length - 1) === '/') {
                    itemUri = itemUri.substr(0, itemUri.length - 1);
                }

                var predicateUri = uri;
                if (predicateUri !== '/' && predicateUri.charAt(predicateUri.length - 1) === '/') {
                    predicateUri = predicateUri.substr(0, predicateUri.length - 1);
                }

                // Ignore casing.
                if (predicateUri.toLowerCase() === itemUri.toLowerCase()) {
                    return item;
                }
            }

            var childItem = this._findItemFromUri(item.Items, uri);
            if (childItem != null) {
                return childItem;
            }
        }

        return null;
    }

    _findItemFromId(items, id) {
        if (items == null || typeof items === "undefined") {
            return null;
        }

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item == null || typeof item === "undefined") {
                continue;
            }
            if (item.Id === id) {
                return item;
            }

            var childItem = this._findItemFromId(item.Items, id);
            if (childItem != null) {
                return childItem;
            }
        }

        return null;
    }

    _findItemFromElement(items, element) {
        if (items == null || typeof items === "undefined") {
            return null;
        }

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item == null || typeof item === "undefined") {
                continue;
            }
            if (item.domElement == element) {
                return item;
            }

            var childItem = this._findItemFromElement(item.Items, element);
            if (childItem != null) {
                return childItem;
            }
        }

        return null;
    }

    _getMenuScrollPosition(menuUri) {
        return this._menuRowScrollPositions[typeof menuUri === 'string' ? menuUri.toLowerCase() : menuUri];
    }

    _storeMenuScrollPosition(scrollLeft, menuUri) {
        var menuScrollPositions = JSON.parse(window.sessionStorage[this._sessionStorageKeyScrollPositions]);

        menuScrollPositions[typeof menuUri === 'string' ? menuUri.toLowerCase() : menuUri] = scrollLeft;

        window.sessionStorage[this._sessionStorageKeyScrollPositions] = JSON.stringify(menuScrollPositions);
    }

    _scrollActiveMenuItemIntoView(rowElement, activeMenuItemElement) {
        var $rowElement = $(rowElement);
        var $item = $(activeMenuItemElement);

        $(function () {
            if ($item.length > 0) {
                var $ftscrollerContainer = $item.closest('.ftscroller_container');
                /* The position of the menu item if it were fully in view in the left corner */
                var offsetFromLeftInsidePosition = $item.offset().left
                    - $ftscrollerContainer.offset().left;
                /* The position of the menu item if it were fully in view in the right corner */
                var offsetFromRightInsidePosition = offsetFromLeftInsidePosition
                    - $ftscrollerContainer.innerWidth()
                    + $item.outerWidth();

                var itemIsOutsideViewOnLeft = offsetFromLeftInsidePosition < 0;
                var itemIsOutsideViewOnRight = offsetFromRightInsidePosition > 0;

                if (itemIsOutsideViewOnLeft) {
                    rowElement._scroller.scrollBy(offsetFromLeftInsidePosition, false, true);
                } else if (itemIsOutsideViewOnRight) {
                    rowElement._scroller.scrollBy(offsetFromRightInsidePosition, false, true);
                }
            }
        });
    }

    _applyMenuScrollPositionFromStorage(rowElement, menuUri) {
        if (this._getMenuScrollPosition(menuUri)) {
            this._setMenuScrollLeft(rowElement, this._getMenuScrollPosition(menuUri));
        }
    }

    _setMenuScrollLeft(rowElement, scrollPosition) {
        /* Set the transform instantly, to remove the jank caused by the menu row being visible before it's possible to set FTScroller.scrollLeft. */
        $(rowElement).find('.ftscroller_x').css('transform', 'translate3d(' + (-1 * scrollPosition) + 'px, 0px, 0px)');

        /* Apart from manually setting the transform, scrollLeft needs to be set for FTScroller to have a valid internal state. */
        if (document.readyState === 'complete'
            || document.readyState === 'loaded'
            || document.readyState === 'interactive') {
            rowElement._scroller.scrollLeft = scrollPosition;
        } else {
            $(function () {
                rowElement._scroller.scrollLeft = scrollPosition;
            });
        }
    }
}
